import axiosClient from '../../../config/api/axios'
import { WORKSPACES } from '@/config/api/endpoints'

export async function fetchWorkspaces(options = {}) {
  const { data } = await axiosClient.get(WORKSPACES, { signal: options.signal })
  return data
}

export async function createWorkspace(payload) {
  const { data } = await axiosClient.post(WORKSPACES, payload)
  return data
}
